export const individualAPI = {
  apiName: "",
  apiURL: "",
  apiMethod: "POST",
  apiTriggerPrompt: "",
  apiGatePrompt: "",
  triggerEvent: "callStart",
  callOnce: true,
  backchannelMessage: "",
  successResponse: "",
  failureResponse: "",
  inputParams: [],
  returnParams: [],
  callStatusMatchValues: [],
  callDirection: ["inbound", "outbound"],
  contextFilter: [],
  sequenceAPIIds: [],
  activationAPIIds: []
};

export const serializeCallStatusMatchValues = (callStatusMatchValues) => {
  if (callStatusMatchValues === "") {
    return [];
  }

  if (Array.isArray(callStatusMatchValues)) {
    return callStatusMatchValues;
  }

  return callStatusMatchValues.split(",");
};

export const deserializeCallStatusMatchValues = (callStatusMatchValues) => {
  return callStatusMatchValues.join(",");
};
